import { alpha } from "@mui/material";
export const MuiInputBase = {
    styleOverrides: {
        root: ({ theme }) => ({
            backgroundColor: alpha(theme.palette.common.white, 0.75)
        }),
        input: ({ theme }) => ({
            "&.Mui-disabled": {
                "WebkitTextFillColor": "unset",
                color: theme.palette.text.secondary
            }
        })
    }
};
//# sourceMappingURL=InputBase.js.map